export const ko = {
    title: '팝업 승인',
    content_sign: '서명 또는 트랜잭션을 완료하려면 계속을 클릭하십시오.',
    content_login: '계속을 클릭하여 지갑 생성 또는 연결을 완료합니다.',
};
